import { render, staticRenderFns } from "./ParentFolderGeneral.vue?vue&type=template&id=4994eeaa&scoped=true&"
import script from "./ParentFolderGeneral.vue?vue&type=script&lang=js&"
export * from "./ParentFolderGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ParentFolderGeneral.vue?vue&type=style&index=0&id=4994eeaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994eeaa",
  null
  
)

export default component.exports